import React from 'react';
import { Building2, Users, Award, TrendingUp } from 'lucide-react';

const About = () => {
  const stats = [
    { icon: Building2, label: 'Banking Partners', value: '15+' },
    { icon: Users, label: 'Expert Team', value: '10+' },
    { icon: Award, label: 'Years Experience', value: '8+' },
    { icon: TrendingUp, label: 'Success Rate', value: '95%' }
  ];

  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-50 to-blue-50/30">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
              About Us
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Welcome to <span className="bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent">Digi Loans Bazaar</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-amber-500 mx-auto mb-6"></div>
          </div>

          {/* Content Grid */}
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Text Content */}
            <div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <span className="font-semibold text-blue-900">Digi Loans Bazaar</span> is a trusted financial consultancy specializing in business loans, hospital project financing, medical equipment funding, and working capital solutions.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                Led by <span className="font-semibold text-blue-900">D.N.V. Prasad</span>, we help entrepreneurs, healthcare professionals, and businesses secure the right funding with minimal hassle and maximum support.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Our mission is to empower growth by providing customized financing solutions through our strong partnerships with leading banks and financial institutions.
              </p>
            </div>

            {/* Image */}
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_hospital-loan-hub/artifacts/gxkjc5tl_Screenshot_20260602_101255_ChatGPT.jpg"
                  alt="Modern Hospital"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl -z-10"></div>
              <div className="absolute -top-6 -left-6 w-32 h-32 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl -z-10"></div>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100"
                >
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-amber-500 bg-clip-text text-transparent mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
